<template>
  <div class="dashboard-promo-banner-cheatgpt" :class="{ open: isOpen }">
    <a :href="bannerLink" class="banner--content">
      <div class="banner-content-wrap">
        <div class="banner--content__left">
          <img class="cheatgpt-logo" src="/static/img/cheatgpt-logo-mini-w.png" alt="">
          <div v-if="!joke" class="promo">
            <div class="promo-intro">
              {{ $gettext('CheatGPT - Launch date is 1st of April!') }}
            </div> 
            <div v-translate>
              Do keep in mind that due to the unusual date of release, you shouldn't count on too many savings! 🙂
            </div>
          </div>
          <div v-else class="promo promo-joke">
            <div class="promo-intro">
              {{ $gettext('April fools!') }}
            </div> 
            <div v-translate>
              We hope we did not get your hopes up too much. And to make sure that people who signed up for nothing are not too annoyed with us, we lowered prices on our yearly Premium subscription today by 20% (only for currently non-Premium subscriptions and only today). Keep in mind though, Gekko Premium is really nice, but not necessary to have a good Gekko experience. So it's up to you.
            </div>
          </div>
        </div>
        <div v-if="!joke" class="banner--content__right">
          <div class="flip-count">
            <span class="flip-title">{{ $gettext('Releasing in') }}</span>
            <FlipCount :time-until="promoEnds" />
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FlipCount from "@/components/dashboard/ui/FlipCount"
import moment from 'moment';
export default {
  name: 'PromoBannerAprils',
  components: {
    FlipCount
  },
  props: {
    promoData: {
      type: Object,
      default: () => {}
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      promoEnds: null,
      bannerType: null,
      debug: false
    }
  },
  computed: {
    ...mapGetters ({ 
      preferredLanguage: 'main/getPreferredLanguage'
    }),
    bannerLink () {
      return '/subscriptions/manage/?selected=year'
    },
    joke () {
      return moment('2023-04-01').isSame(Date.now(), 'day')
    }
  },
  created () {
    if (this.promoData) {
      let dateformat = (this.preferredLanguage === 'en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
      this.promoEnds = moment(this.promoData.end_time).add(1, 'days').format(dateformat)
    }
  },
  mounted () {
    setTimeout(() => {
      this.isOpen = true
    }, 1000)
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.dashboard-promo-banner {
  .banner-price-tag {
    position: relative;
    display: inline;
    &:before {
      content: '';
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 0;
      height: 4px;
      background: white;
      transition: width 1s ease-in-out;
      transition-delay: 1s;
    }
  }
  &.open {
    .banner-price-tag {
      &:before {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
  .dashboard-promo-banner-cheatgpt {
    cursor: pointer;
    display: flex;
    align-items: center;
    background-image: linear-gradient(to right top, #545094, #505b9b, #4e65a2, #4d6fa7, #4f79ab, #4883b0, #438cb3, #4295b5, #39a0b4, #3faaaf, #50b3a7, #69bb9d);
    height: 0px;
    // overflow: hidden;
    overflow: visible;
    transition: height 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    margin-bottom: 0.5rem;
    border-radius: 12px;
    margin-left: 1rem;
    margin-right: 1rem;

    .banner-price-tag {
      &:before {
        bottom: -2px;
        height: 2px;
      }
    }

    .banner--content {
      &:hover {
        text-decoration: none;
      }
      display: flex; 
      padding: 0.75rem;
      font-weight: 900; 
      flex-direction: column; 
      justify-content: center; 
      width: 100%; 
      // max-width: 80rem; 
      height: 100%; 

      @media (min-width: 640px) { 
        padding-left: 1.5rem;
        padding-right: 1.5rem; 
      }

      @media (min-width: 1024px) { 
        padding-left: 2rem;
        padding-right: 2rem; 
      }

      transition: all 0.5s cubic-bezier(0.750, 0.020, 0.190, 1.290);
      opacity: 0;
      transform: scale(0.9);
      .banner-content-wrap {
        display: flex; 
        flex-wrap: wrap; 
        justify-content: space-between; 
        align-items: center; 
      }
      &__left {
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        justify-content: space-evenly;
        width: 100%; 

        @media (min-width: 640px) { 
          flex-direction: row; 
          flex: 1 1 0%; 
          width: 0; 
        }

        .promo {
          display: block; 
          color: #ffffff; 
          text-align: center; 

          font-size: 17px;
          line-height: 1.4;
          text-align: left;
          font-weight: 100;
          padding: 1rem;
          padding-right: 2rem;
          flex: 1;

          .promo-intro {
            display: block;
            margin-bottom: 1rem;
            font-family: 'DINNextLTPro-Medium';
          }
          .discount-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            border: 1px dashed white;
            box-shadow: 0 0 0 2px #C42F52, rgba(0,0,0,0.2) 0px 15px 35px 0px, rgba(0,0,0,0.12) 0px 5px 15px 0px;
            background: #C42F52;
            color: white;
            border-radius: 8px;
            padding: 0 0.5rem;
            margin: 0 10px;
          }
        }
        .limited-time {
          font-size: 1rem;
          text-transform: uppercase;
          color: white;
        }
      }
      &__right {
        display: flex; 
        margin-top: 0.25rem; 
        flex-shrink: 0; 
        order: 3; 
        justify-content: center; 
        width: 100%; 

        @media (min-width: 640px) { 
          margin-top: 0; 
          order: 2; 
          width: auto; 
        }
        .pre-deadline {
          display: flex; 
          color: #ffffff; 
          font-size: 1.125rem;
          line-height: 1.75rem; 
          text-transform: uppercase; 
        }
        .flip-count {
          display: flex; 
          color: #333; 
          font-size: 0.875rem;
          line-height: 1.25rem; 
          text-align: center; 
          text-transform: uppercase; 

          padding: 1rem;
          background: white;
          border-radius: 12px;

          .flip-title {
            font-size: 18px;
          }
          .promo-timer {
            color: #333; 
          }

          @media (min-width: 640px) { 
            flex-direction: column; 
          }
          .flip-title {
            margin-bottom: 0.5rem; 
          }
        }
      }
    }
    &.open {
      height: auto;
      .banner--content {
        opacity: 1;
        transform: scale(1);
        transition-delay: 0.5s;
      }
    }
    @media (min-width: 640px) {
      &.open {
        height: auto;
      }
    }
    
    

  }
</style>
